import React from 'react';
import PropTypes from 'prop-types';
import LoaderButton from '../loader-button/LoaderButton';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const AlertModal = ({ showAlert, setShowAlert, loader, deleteKey, keyId, keyName }) => {
  return (
    <>
      <Modal isOpen={showAlert} toggle={() => setShowAlert(!showAlert)}>
        <ModalHeader>Delete Confirmation</ModalHeader>
        <ModalBody>
          You are about to delete the keyId{' '}
          <span className="active" data-testid={'key-name'}>
            {keyName}
          </span>
          , this change can not be undone.
        </ModalBody>
        <ModalFooter>
          <>
            <Button color="falcon-danger" onClick={() => setShowAlert(!showAlert)}>
              Cancel
            </Button>
            <LoaderButton
              color="falcon-primary"
              onClick={e => deleteKey(keyId)}
              isLoading={loader}
              name="save-and-add"
              data-testid={'delete-key-btn'}
            >
              Delete
            </LoaderButton>
          </>
        </ModalFooter>
      </Modal>
    </>
  );
};

AlertModal.propTypes = {
  keyId: PropTypes.string,
  loader: PropTypes.bool,
  deleteKey: PropTypes.func,
  setShowAlert: PropTypes.func,
  showAlert: PropTypes.bool,
  keyName: PropTypes.string
};

export default AlertModal;
